/* tslint:disable */
/* eslint-disable */
/**
 * MTX Brokerage API
 * Brokerage agent-facing API for dispositions, listings, and transactions
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CurrentSection } from './CurrentSection';
import {
    CurrentSectionFromJSON,
    CurrentSectionFromJSONTyped,
    CurrentSectionToJSON,
} from './CurrentSection';
import type { FormData } from './FormData';
import {
    FormDataFromJSON,
    FormDataFromJSONTyped,
    FormDataToJSON,
} from './FormData';
import type { SectionsCompleted } from './SectionsCompleted';
import {
    SectionsCompletedFromJSON,
    SectionsCompletedFromJSONTyped,
    SectionsCompletedToJSON,
} from './SectionsCompleted';

/**
 * Request to update an existing visit form draft (progressive save).
 * @export
 * @interface UpdateVisitFormRequest
 */
export interface UpdateVisitFormRequest {
    /**
     * 
     * @type {FormData}
     * @memberof UpdateVisitFormRequest
     */
    formData?: FormData;
    /**
     * 
     * @type {CurrentSection}
     * @memberof UpdateVisitFormRequest
     */
    currentSection?: CurrentSection;
    /**
     * 
     * @type {SectionsCompleted}
     * @memberof UpdateVisitFormRequest
     */
    sectionsCompleted?: SectionsCompleted;
}

/**
 * Check if a given object implements the UpdateVisitFormRequest interface.
 */
export function instanceOfUpdateVisitFormRequest(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function UpdateVisitFormRequestFromJSON(json: any): UpdateVisitFormRequest {
    return UpdateVisitFormRequestFromJSONTyped(json, false);
}

export function UpdateVisitFormRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateVisitFormRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'formData': !exists(json, 'form_data') ? undefined : FormDataFromJSON(json['form_data']),
        'currentSection': !exists(json, 'current_section') ? undefined : CurrentSectionFromJSON(json['current_section']),
        'sectionsCompleted': !exists(json, 'sections_completed') ? undefined : SectionsCompletedFromJSON(json['sections_completed']),
    };
}

export function UpdateVisitFormRequestToJSON(value?: UpdateVisitFormRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'form_data': FormDataToJSON(value.formData),
        'current_section': CurrentSectionToJSON(value.currentSection),
        'sections_completed': SectionsCompletedToJSON(value.sectionsCompleted),
    };
}

